"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SuggestionField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["input", "label", "meta", "name", "TextFieldProps"];
var useStyles = (0, _makeStyles.default)({
  autoComplete: {
    padding: '6px 9px 5px 9px !important'
  }
});
function SuggestionField(_ref) {
  var input = _ref.input,
    label = _ref.label,
    meta = _ref.meta,
    name = _ref.name,
    TextFieldProps = _ref.TextFieldProps,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var value = input.value,
    onBlur = input.onBlur,
    onChange = input.onChange,
    onFocus = input.onFocus;
  var _meta$data = meta.data,
    data = _meta$data === void 0 ? {} : _meta$data,
    inputError = meta.error,
    touched = meta.touched,
    warning = meta.warning,
    modifiedSinceLastSubmit = meta.modifiedSinceLastSubmit;
  var error = inputError || !modifiedSinceLastSubmit && data.submitError;
  var handleInputChange = function handleInputChange(event, newValue) {
    onChange(newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_material.Autocomplete, (0, _extends2.default)({
    freeSolo: true,
    openOnFocus: true,
    options: [],
    selectOnFocus: true
  }, rest, {
    classes: {
      inputRoot: classes.autoComplete
    },
    inputValue: value,
    onInputChange: handleInputChange,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, TextFieldProps, params, {
        error: touched && !!(error || warning),
        label: label,
        onBlur: onBlur,
        onFocus: onFocus,
        variant: "outlined"
      }));
    }
  }));
}